export enum ImportStylesModalStepsEnums {
  SELECT_IMPORT_LINE_ITEMS_FLOW = 0,
  SEARCH_ORDERS,
  SELECT_STYLES,
  SELECT_LINE_ITEMS,
}
